import { Panel } from 'primereact/panel';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

const PanelObs = ({ eventoObservado, funAlCerrar, observacion, setObservacion, procesaObs }) => {
    const mensajes = eventoObservado.observacion.substring(25).split(/\(-\)/);
    const mensajeSal = mensajes.slice(1);
    //setObservacion('');
    return (
        <Panel header="Observacion" >
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <ul>
                        {mensajeSal.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
                <div className="field col-12 md:col-12">
                    <label htmlFor="txtObservacion">Ingrese una Observacion:</label>
                    <InputTextarea inputId="txtObservacion" value={observacion} onChange={(e) => setObservacion(e.target.value)} />
                </div>
                <div className="field col-12 md:col-12">
                    <Button label="Registrar" onClick={() => funAlCerrar(eventoObservado) } loading={procesaObs} />
                </div>
            </div>
        </Panel>
    );
};

export default PanelObs;
